import React from 'react'
import { userSelector } from 'src/selectors'
import { connect } from 'react-redux'
// import styles from '../panel.scss'
import cn from 'classnames'
import MembershipInfo from '../../membership-info/MembershipInfo'
import Button from 'components/common/Button'
import {
  PurchaseWorkflowNode,
  setCheckoutModalOpen,
  setDefaultWorkflowNode
} from 'src/actions/stripeCheckout'
import { cancelSubscription } from '../../../../actions/stripe'
import PropTypes from 'prop-types'
import {
  getPlanBySlug,
  getPlanTypeBySlug,
  PlanSlugs,
  PlanType
} from 'src/services/stripe_checkout_configs'
import { LeftOutlined } from '@ant-design/icons'
import { updateMenuPanel } from 'src/actions/frontend'
import { PanelSlug } from '../PanelContainer'
import {
  GreenTick,
  PurpleTick,
  BlueTick
} from 'containers/StripeCheckoutContainer/components/description-components'
import CreditIcon from 'assets/icons/credit-icon.png'
import styles from './membership-detail-panel.scss'
import { isMobile } from 'services/browser_detection'
import { routerActions } from 'react-router-redux'
import { message } from 'antd'
import { fetchUserGQ } from 'src/actions/user'
import LoadingComponent from 'components/common/LoadingComponent/LoadingComponent'
import PopConfirm from 'components/common/PopConfirm/PopConfirm'

const PlanThemMapping = {
  [PlanType.Free]: 'free',
  [PlanType.Essentials]: 'essential',
  [PlanType.Premium]: 'premium',
  [PlanType.Basic]: 'basic',
  [PlanType.InvitationMaker]: 'invitation-maker',
  [PlanType.partyHost]: 'party-host'
}

class MembershipDetailPanel extends React.Component {
  state = {
    cancelling: false,
    confirmDlgVisible: false
  }

  openPurchaseModal = () => {
    this.props.startMembershipPlanCheckout()
  }

  renderMemberShipDescriptionBySlug = slug => {
    const plan = getPlanBySlug(slug)

    switch (plan?.slug) {
      case PlanSlugs.PremiumAnnually:
        return (
          <ul>
            <li>
              <PurpleTick />
              <b>300 included credits</b> - send text invites with our Automated Invite technology
              to track views and send RSVP reminders
            </li>
            <li>
              <PurpleTick />
              <b>Thousands</b> of premium images and videos and flyer and invitation templates
            </li>
            <li>
              <PurpleTick />
              Send <b>Instant Updates</b> by text to tell guests last minute changes or important
              information
            </li>
            <li>
              <PurpleTick />
              <b>Unlimited polls</b> to efficiently plan best times with your group, putting an end
              to endless group texts
            </li>
            <li>
              <PurpleTick />
              Access to <b>purchase credits anytime</b> you need more - for larger events and other
              member benefits
            </li>
            <li>
              <PurpleTick />
              Sell tickets like a pro with <b>the lowest fees</b> in the industry
            </li>
            <li>
              <PurpleTick />
              Share <b>up to 20</b> Event Videos to the Media Album
            </li>
          </ul>
        )
      case PlanSlugs.EssentialsAnnually:
        return (
          <ul>
            <li>
              <GreenTick />
              <b>Thousands</b> of premium images and videos and flyer and invitation templates
            </li>
            <li>
              <GreenTick />
              Send <b>Instant Updates</b> by text to tell guests last minute changes or important
              information
            </li>
            <li>
              <GreenTick />
              <b>Unlimited polls</b> to efficiently plan best times with your group, putting an end
              to endless group texts
            </li>
            <li>
              <GreenTick />
              <b>60 included credits/month</b> - send text invites with our Smart Invite technology
              to track views and send RSVP reminders
            </li>
            <li>
              <GreenTick />
              Access to <b>purchase credits anytime</b> you need more - for larger events and other
              member benefits
            </li>
            <li>
              <GreenTick />
              Sell tickets like a pro with <b>the lowest fees</b> in the industry
            </li>
          </ul>
        )
      case PlanSlugs.EssentialsMonthly:
        return (
          <ul>
            <li>
              <GreenTick />
              <b>Thousands</b> of premium images and videos and flyer and invitation templates
            </li>
            <li>
              <GreenTick />
              Send <b>Instant Updates</b> by text to tell guests last minute changes or important
              information
            </li>
            <li>
              <GreenTick />
              <b>Unlimited polls</b> to efficiently plan best times with your group, putting an end
              to endless group texts
            </li>
            <li>
              <GreenTick />
              <b>20 included credits/month</b> - send text invites with our Smart Invite technology
              to track views and send RSVP reminders
            </li>
            <li>
              <GreenTick />
              Access to <b>purchase credits anytime</b> you need more - for larger events and other
              member benefits
            </li>
            <li>
              <GreenTick />
              Sell tickets like a pro with <b>the lowest fees</b> in the industry
            </li>
          </ul>
        )
      case PlanSlugs.BasicAnnually:
        return (
          <ul>
            <li>
              <BlueTick />
              <b>Unlimited polls</b> to efficiently plan best times with your group, putting an end
              to endless group texts
            </li>
            <li>
              <BlueTick />
              <b>20 included credits</b> - send text invites with our Automated Invite technology to
              track views and send RSVP reminders
            </li>
            <li>
              <BlueTick />
              Access to <b>purchase credits anytime</b> you need more - for larger events and other
              member benefits
            </li>
            <li>
              <BlueTick />
              Share <b>up to 20</b> Event Videos in the Event Chat and Media Album
            </li>
          </ul>
        )
      case PlanSlugs.InvitationMakerMonthly:
      case PlanSlugs.InvitationMakerAnnually:
        return (
          <ul>
            <li>
              <BlueTick />
              <b>Thousands</b> of premium images and videos and flyer and invitation templates
            </li>
            <li>
              <BlueTick />
              <b>Unlimited polls</b> to efficiently plan best times with your group, putting an end
              to endless group texts
            </li>
            <li>
              <BlueTick />
              Access to <b>purchase credits anytime</b> you need more - for larger events and other
              member benefits
            </li>
            <li>
              <BlueTick />
              Share <b>4</b> Event Videos to the Media Album
            </li>
          </ul>
        )
      case PlanSlugs.PartyHostMonthly:
      case PlanSlugs.PartyHostAnnually:
        return (
          <ul>
            <li>
              <GreenTick />
              <b>50 included credits/month</b> — send text invites with our Automated Invite
              technology to track views and send RSVP reminders
            </li>
            <li>
              <GreenTick />
              <b>Thousands</b> of premium images and videos and flyer and invitation templates
            </li>
            <li>
              <GreenTick />
              Send <b>Instant Updates</b> by text to tell guests last minute changes or important
              information
            </li>
            <li>
              <GreenTick />
              <b>Unlimited polls</b> to efficiently plan best times with your group, putting an end
              to endless group texts
            </li>
            <li>
              <GreenTick />
              Access to <b>purchase credits anytime</b> you need more - for larger events and other
              member benefits
            </li>
            <li>
              <GreenTick />
              Sell tickets like a pro with <b>the lowest fees</b> in the industry
            </li>
            <li>
              <GreenTick />
              Share <b>up to 10</b> Event Videos to the Media Album
            </li>
          </ul>
        )
      case PlanSlugs.Free:
      default:
        return <></>
    }
  }

  handlePurchaseCredits = () => {
    const { startCreditsCheckout, changePurchaseCredits } = this.props
    if (isMobile()) {
      changePurchaseCredits()
    } else {
      startCreditsCheckout()
    }
  }

  handleStripeCancelSubscription = () => {
    this.setState({ ...this.state, cancelling: true, confirmDlgVisible: false })
    this.props.doCancelStripeSubscription({
      sc: () => {
        // it's supposed to completed in few seconds
        const to = setTimeout(() => {
          message.error('We’re unable to process your cancellation request. Please try again later.')
          clearTimeout(to)
          clearInterval(it)
          it = null
          this.setState({ ...this.state, cancelling: false })
        }, 5000)

        // wait for backend's data to change
        let it = setInterval(() => {
          this.props.loadUserGQ(() => {
            if (this.props.currentSub.cancel_at_period_end && it) {
              clearTimeout(to)
              clearInterval(it)
              it = null
              this.setState({ ...this.state, cancelling: false })
              message.success('You have successfully cancelled your subscription.')
            }
          })
        }, 300)
      },

      ec: () => {
        message.error('We’re unable to process your cancellation request. Please try again later.')
        this.setState({ ...this.state, cancelling: false })
      }
    })
  }

  render() {
    const { currentSub } = this.props
    let theme = 'free'
    let canSeeUpgradePlan = false
    let isMembership = false

    if (currentSub) {
      theme = PlanThemMapping[getPlanTypeBySlug(currentSub.plan.slug)] || 'free'
      isMembership = currentSub.plan.slug !== PlanSlugs.Free
      canSeeUpgradePlan = currentSub.plan.slug !== PlanSlugs.PremiumAnnually && isMembership
    }

    return (
      <main className={styles['membership-info-panel']}>
        <div
          className={cn('web-view', styles['go-back-btn'])}
          onClick={() => {
            this.props.changeMenuPanel(PanelSlug.Profile)
          }}
        >
          <LeftOutlined style={{ fontSize: 24 }} />
        </div>
        <section className={styles['content-container']}>
          <section className={cn(styles['profile-container'], styles[theme])}>
            <MembershipInfo isInDetail />
            <div className={styles['purchase-credit-button']} onClick={this.handlePurchaseCredits}>
              <img src={CreditIcon} width={18} />
              Purchase Credits
            </div>
          </section>
          <section className={styles['description-title']}>membership benefits</section>
          <section className={cn(styles['membership-description-container'])}>
            {this.renderMemberShipDescriptionBySlug(currentSub?.plan?.slug)}
          </section>
        </section>
        <section className={styles['membership-actions']}>
          {canSeeUpgradePlan && (
            <Button
              onClick={this.openPurchaseModal}
              className={cn(styles['upgrade-button'], styles[theme])}
            >
              SEE UPGRADE OPTIONS
            </Button>
          )}
          {!currentSub?.cancel_at_period_end && <p className={styles['cancel-button']}
            onClick={() => {
              if (currentSub.subscription_type !== 'stripe') {
                this.openPurchaseModal()
              } else {
                this.setState({ ...this.state, confirmDlgVisible: true })
              }
            }
            }>
            Cancel My Membership
          </p>}
        </section>
        {this.state.cancelling && <LoadingComponent light />}
        <PopConfirm
          visible={this.state.confirmDlgVisible}
          onClose={() => this.setState({ ...this.state, confirmDlgVisible: false })}
          cancelText="No"
          confirmText="Yes"
          type="delete"
          onConfirm={this.handleStripeCancelSubscription}
        >
          Are you sure you want to cancel your membership?<br />
          Your membership will end once your current subscription expires, and you will no longer be charged.
        </PopConfirm>
      </main>
    )
  }
}

MembershipDetailPanel.propTypes = {
  currentSub: PropTypes.object,
  startMembershipPlanCheckout: PropTypes.func,
  changeMenuPanel: PropTypes.func,
  startCreditsCheckout: PropTypes.func,
  changePurchaseCredits: PropTypes.func,
  doCancelStripeSubscription: PropTypes.func,
  loadUserGQ: PropTypes.func
}

const mapStateToProps = state => {
  return {
    currentSub: userSelector(state)?.current_subscription
  }
}

const mapDispatchToProps = dispatch => {
  return {
    startCreditsCheckout: () => {
      dispatch(setDefaultWorkflowNode(PurchaseWorkflowNode.PurchaseCredits))
      dispatch(setCheckoutModalOpen(true))
    },
    startMembershipPlanCheckout: () => {
      let node
      if (isMobile()) {
        node = PurchaseWorkflowNode.PurchasePlanOnMobileApp
      } else {
        node = PurchaseWorkflowNode.UpgradePlan
      }
      dispatch(setDefaultWorkflowNode(node))
      dispatch(setCheckoutModalOpen(true))
    },
    changeMenuPanel: panel => {
      dispatch(updateMenuPanel(panel))
    },
    changePurchaseCredits: () => dispatch(routerActions.push('/purchase-credits')),
    doCancelStripeSubscription: ({ sc, ec }) => {
      dispatch(cancelSubscription({
        onSuccessCallback: sc,
        onErrorCallback: ec
      }))
    },
    loadUserGQ: (sc) => {
      dispatch(fetchUserGQ(sc))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MembershipDetailPanel)
